import { DXN } from '../types';
export default {
  type: DXN,
  service: 'DEXON',
  url: 'https://mainnet-rpc.dexon.org',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
